<template>
  <div class="mobile-why-process">
    <div class="mobile-why-process__top">
      <div class="mobile-why-process__top-title">{{ topTitle }}</div>
      <div>
        <div v-for="(item, i) in topItems" :key="`top-${i}`" class="mobile-why-process__top-desc">
          <span>{{ item }}</span>
          <img :src="topIcon" alt="">
        </div>
      </div>
    </div>
    <div
      class="mobile-why-process__bottom"
      :style="{ backgroundImage: `url(${bottomBackground})`,left }"
    >
      <div class="mobile-why-process__bottom-title">{{ bottomTitle }}</div>
      <div>
        <div v-for="(item, i) in bottomItems" :key="`bottom-${i}`" class="mobile-why-process__bottom-desc">
          <span class="mobile-why-process__bottom-desc-text">
            <em class="mobile-why-process__bottom-desc-arrow">→</em>
            <span>{{ item }}</span>
          </span>
          <img :src="bottomIcon" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileWhyProcessCompare',
  props: {
    left: {
      type: String,
      default: '0px'
    },
    topTitle: {
      type: String,
      default: ''
    },
    topItems: {
      type: Array,
      default: () => []
    },
    bottomTitle: {
      type: String,
      default: ''
    },
    bottomItems: {
      type: Array,
      default: () => []
    },
    topIcon: {
      type: String,
      default: 'https://file.zmxs.com.cn/img/2026-09-02140131.png'
    },
    bottomIcon: {
      type: String,
      default: 'https://file.zmxs.com.cn/img/2026-09-02140132.png'
    },
    bottomBackground: {
      type: String,
      default: 'https://file.zmxs.com.cn/img/2026-09-0200003.png'
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-why-process {
  position: relative;
  background: #F7F7F7;
  border-radius: 32px;
  border: 1px solid #D8CBFF;
  margin-top: 60px;
  margin-bottom: 37px;
  padding-bottom: 100px;
}

.mobile-why-process__top {
  padding: 35px 65px;
}

.mobile-why-process__top-title {
  font-size: 24px;
  line-height: 1;
  font-weight: 700;
  color: #6E7494;
}

.mobile-why-process__top-desc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  margin-top: 27px;
  line-height: 1.4;
  font-weight: 700;
  color: #6E7494;

  & + & {
    margin-top: 25px;
  }

  span {
    flex: 1;
    text-decoration-line: line-through;
    text-decoration-thickness: 1px;
    text-decoration-color: currentColor;
  }

  img {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
}

.mobile-why-process__bottom {
  width: 100%;
  position: absolute;
  top: 300px;
  left: 0;
  margin-top: 28px;
  padding: 60px 65px;
  background: center center / cover no-repeat;
  background-size: 100%;
  border-radius: 32px;
}

.mobile-why-process__bottom-title {
  font-size: 32px;
  line-height: 1;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 34px;
}

.mobile-why-process__bottom-desc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 62px;
  font-size: 20px;
  line-height: 1.4;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.92);

  & + & {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  img {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
}

.mobile-why-process__bottom-desc-text {
  flex: 1;
  display: inline-flex;
  align-items: center;
}

.mobile-why-process__bottom-desc-arrow {
  margin-right: 10px;
  font-style: normal;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.92);
  flex-shrink: 0;
}
</style>
